import { types } from "mobx-state-tree";
import { exportImageTileSpec, isLegacyImageTileImport, convertLegacyImageTile } from "./image-import-export";
import { tileContentAPIActions } from "../tile-model-hooks";
import { TileContentModel } from "../tile-content";
import { isPlaceholderImage } from "../../../utilities/image-utils";
import placeholderImage from "../../../assets/image_placeholder.png";
export const kImageTileType = "Image";
// This is only used directly by tests
export function defaultImageContent(options) {
    return ImageContentModel.create({ url: (options === null || options === void 0 ? void 0 : options.url) || placeholderImage });
}
export const ImageContentModel = TileContentModel
    .named("ImageTool")
    .props({
    type: types.optional(types.literal(kImageTileType), kImageTileType),
    url: types.maybe(types.string),
    filename: types.maybe(types.string),
})
    .volatile(self => ({
    metadata: undefined
}))
    .preProcessSnapshot(snapshot => {
    return isLegacyImageTileImport(snapshot)
        ? convertLegacyImageTile(snapshot)
        : snapshot;
})
    .views(self => ({
    get isUserResizable() {
        return true;
    },
}))
    .views(self => ({
    get hasValidImage() {
        const url = self.url;
        return !!url && !isPlaceholderImage(url);
    },
    exportJson(options) {
        return exportImageTileSpec(self.url, self.filename, options);
    }
}))
    .actions(self => tileContentAPIActions({
    doPostCreate(metadata) {
        self.metadata = metadata;
    },
}))
    .actions(self => ({
    setUrl(url, filename) {
        self.url = url;
        self.filename = filename;
    },
    updateImageUrl(oldUrl, newUrl) {
        if (!oldUrl || !newUrl || (oldUrl === newUrl))
            return;
        if (self.url === oldUrl)
            self.url = newUrl;
    }
}));
//# sourceMappingURL=data:application/json;base64,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